import React from "react";
import AboutUsSection from "../AboutSection";
import Footer from "../Footer";
import Navbar from "../Navbar";

const AboutPage = () => {
  return (
    <div>
      <Navbar />
      <AboutUsSection />
      <Footer />
    </div>
  );
};

export default AboutPage;
